import { isBoolean, isPlainObject, isString } from 'remeda'

// Public types ----------------------------------------------------------------

export type OfficeKind = 'spreadsheet' | 'docx'
export type OfficeRequest = {
  readonly kind: OfficeKind
  readonly buffer: ArrayBuffer
}
export type OfficeResult =
  | {
      readonly status: 'success'
      readonly html: string
      readonly truncated: boolean
    }
  | { readonly status: 'error' }

// Public functions ------------------------------------------------------------

// Accepts only the document formats handled by the local parser.
export const isOfficeKind = (value: unknown): value is OfficeKind =>
  value === 'spreadsheet' || value === 'docx'

// Validates the transferred file before invoking third-party parsers.
export const isOfficeRequest = (value: unknown): value is OfficeRequest =>
  isPlainObject(value) &&
  isOfficeKind(value.kind) &&
  value.buffer instanceof ArrayBuffer

// Keeps malformed worker messages out of the rendering boundary.
export const isOfficeResult = (value: unknown): value is OfficeResult =>
  isPlainObject(value) &&
  (value.status === 'error' ||
    (value.status === 'success' &&
      isString(value.html) &&
      isBoolean(value.truncated)))
